import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { FormValues, FormValuesALIEO, Owner } from '@funnels/types';

import { hasExclusiveAssetOwnershipByApplicantType } from './hasExclusiveAssetOwnershipByApplicantType';

export const getTotalConstructionCosts = (values: FormValuesALIEO, assetIndex: number) => {
  return (
    get(values, FIELD_PATHS.ASSET_BUILD_PRICE_AMOUNT(assetIndex), 0) +
    get(values, FIELD_PATHS.ASSET_OTHER_CONSTRUCTION_COSTS(assetIndex), 0)
  );
};

export const getFinalEstimatedValue = (values: FormValuesALIEO, assetIndex: number) => {
  return getTotalConstructionCosts(values, assetIndex) + get(values, FIELD_PATHS.ASSET_LAND_VALUE(assetIndex), 0);
};

/**
 * This is pure calculation function, you will get result after you pass values and assetindex.
 * You can use this function anywhere.
 * Especially use this within config file which cannot invoke any hooks
 */
export const calculateConstruction = (
  assetIndex: number,
  values: FormValues
): {
  isConstruction: boolean;
  isConstructionFormValue?: boolean;
  isLogicConstruction: boolean;
} => {
  const isConstructionFormValue = get(values, FIELD_PATHS.ASSET_IS_CONSTRUCTION(assetIndex));
  const propertyStatus = get(values, FIELD_PATHS.ASSET_PROPERTY_STATUS(assetIndex));
  const propertyType = get(values, FIELD_PATHS.ASSET_PROPERTY_TYPE(assetIndex));

  const owners: Owner[] = get(values, FIELD_PATHS.ASSET_OWNERS(assetIndex), []);

  const allOwnersAreGuarantor = hasExclusiveAssetOwnershipByApplicantType(values, owners, FIELD_VALUES.GUARANTOR);

  const isLogicConstruction =
    propertyStatus === FIELD_VALUES.VACANT_LAND && propertyType !== FIELD_VALUES.LAND && !allOwnersAreGuarantor;
  /**
   * There are two scenarios
   * 1. asset does not have <isConstruction> flag - old asset
   *    we use the <isLogicConstruction> to indicate whether the asset is construction asset or not
   * 2. asset has <isConstruction> flag - new asset
   *    we use <isConstructionFormValue> to indicate whether the asset is construction asset or not
   * case 1 - <isConstructionFormValue> === undefined:
   *    <isConstruction> will equal to isLogicConstruction
   * case 2 - <isConstructionFormValue> === true:
   *    <isConstruction> === true
   * case 3 - <isConstructionFormValue> === false:
   *    <isConstruction> === false
   */
  const isConstruction = isConstructionFormValue || (isConstructionFormValue !== false && isLogicConstruction);
  return { isConstruction, isConstructionFormValue, isLogicConstruction };
};
